import classNames from 'classnames';
import React, { memo, useMemo } from 'react';
import WebImage from "./tailwind/WebImage";

// position = 'top' | 'bottom'

const ProductDimensions = ({ dimensionSpecs, displayName, dimensionImage, position = 'top' }) => {
  const dimensionsCapacity = useMemo(
    () =>
      dimensionSpecs?.capacity && (
        <div
          className={classNames('col-12 text-center', {
            'mt-4': position === 'bottom',
            'mb-4': position === 'top',
          })}>
          <ul className='product-capacities'>
            {dimensionSpecs.capacity.cans && (
              <li>
                <div className='product-capacities__icon'>
                  <span className='plum-icon plum-icon-can'></span>
                </div>
                <p className='product-capacities__text'>
                  Up to {dimensionSpecs.capacity.cans.value} can capacity
                </p>
              </li>
            )}
            {dimensionSpecs.capacity.quarts && dimensionSpecs.capacity.gals && (
              <li>
                <div className='product-capacities__icon'>
                  <span className='plum-icon plum-icon-water'></span>
                </div>
                <p className='product-capacities__text'>
                  {dimensionSpecs.capacity.quarts.value} qt / {dimensionSpecs.capacity.gals.value} gals of
                  water
                </p>
              </li>
            )}
            {dimensionSpecs.capacity.ice && (
              <li>
                <div className='product-capacities__icon'>
                  <span className='plum-icon plum-icon-ice'></span>
                </div>
                <p className='product-capacities__text'>
                  Holds {dimensionSpecs.capacity.ice.value} lb of ice
                </p>
              </li>
            )}
          </ul>
        </div>
      ),
    [dimensionSpecs, position]
  );

  return (
    <section id='ProductComparison' className='product-comparison-tool'>
      <div className='row justify-content-center'>
        {position === 'top' && dimensionsCapacity}

        <div className='col-12 dimensions'>
          <WebImage webImage={dimensionImage} alt={`${displayName} Dimensions`} className='spec active' />
        </div>

        {position === 'bottom' && dimensionsCapacity}
      </div>
    </section>
  );
};

ProductDimensions.defaultProps = {
  displayName: 'Product',
};

export default memo(ProductDimensions);
